import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';


export const ContentData = styled.div`
    background: ${(props) => props.theme.white};
    padding: 24px;
    border-radius: 16px;
    margin-bottom: 32px;
    margin-top: 32px;
    border: 1px solid ${(props) => props.theme.borderWhite};

    & .MuiGrid-item {
        display: flex;
        flex-direction: column;
        
        & label {
            color: ${(props) => props.theme.grey};
        }
        
        & span {
            color: ${(props) => props.theme.black};
            font-size: ${theme.font.size16};
        }
    }

    @media screen and (max-width: 950px) {
        padding: 24px 16px;
    }
`
